import React, { useState, useEffect, useRef } from "react";
// import { useDispatch } from "react-redux";
import { ENV } from "../../../config/config";
import { useGetRolesQuery, useDeleteRoleMutation, useGetPermissionQuery } from "../../../redux/api";
import FullPageLoader from "../../../components/FullPageLoader/FullPageLoader";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import validator from "validator";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import PermissionsModal from "./permissionsModalComponent";
import localeInfo from "rc-pagination/lib/locale/en_US";
import {
  Button,
  Card,
  Form,
  Table,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
  FormGroup,
} from "react-bootstrap";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";

// ... (skipping to usage)

// In the component render:
// Replace <FontAwesomeIcon icon={faPlus} /> with <FaPlus />
// Replace <i className="fas fa-eye"></i> or button content with <FaEye />

// IMPORTANT: The original code used mixed FontAwesomeIcon component AND <i> tags with "fas fa-..." classes.
// The error log says "Can't resolve '@fortawesome/react-fontawesome'".
// I need to replace the import.
// And checking the file content in memory (from previous turn Step 66):
// Line 26: import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Line 27: import { faPlus } from "@fortawesome/free-solid-svg-icons";
// Line 375: <FontAwesomeIcon icon={faPlus} />
// Line 435: <i className="fas fa-eye"></i>  <-- This was using the CSS version, which is also gone.
// Line 459: <i className="fas fa-edit"></i>
// Line 485: <i className="fas fa-trash"></i>

// So I must replace BOTH the component usage and the <i> tag usage with React Icons.

// Let's do imports first.
import Select from "react-select";

var CryptoJS = require("crypto-js");

const StaffPermissions = () => {
  const initialRole = {
    /**  system permissions **/

    /**  system permissions **/
    // props.status (i.e: true for active & false for in-active)

    viewDashboard: false,

    // Staff
    addStaff: false,
    editStaff: false,
    deleteStaff: false,
    viewStaff: false,

    // Role
    addRole: false,
    editRole: false,
    deleteRole: false,
    viewRole: false,

    // Category
    addCategory: false,
    editCategory: false,
    deleteCategory: false,
    viewCategory: false,

    // Content
    viewContent: false,
    addContent: false,
    editContent: false,
    deleteContent: false,

    // Document
    addDocument: false,
    // editDocument: false,
    deleteDocument: false,
    viewDocument: false,

    // Event
    addEvent: false,
    editEvent: false,
    deleteEvent: false,
    viewEvent: false,

    // Gallery
    addGallery: false,
    // editGallery: false,
    deleteGallery: false,
    viewGallery: false,

    // Settings
    viewSetting: false,
    editSetting: false,

    // Team Member
    addTeamMember: false,
    editTeamMember: false,
    deleteTeamMember: false,
    viewTeamMember: false,

    // Slider
    addSlider: false,
    editSlider: false,
    deleteSlider: false,
    viewSlider: false,

    viewAbout: false,
    editAbout: false,

    status: true,
  };

  const [roleModal, setroleModal] = useState(false);
  const [modalType, setModalType] = useState(0);
  const [titleMsg, setTitleMsg] = useState("");
  const [currentUserRole, setCurrentUserRole] = useState({});
  const [currentRoleId, setCurrentRoleId] = useState("");
  const [roles, setRoles] = useState();
  const [search, setSearch] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState(false);
  const [resetButton, setResetButton] = useState(false);
  const [title, setTitle] = useState("");
  const [id, setId] = useState();
  const [selectAll, setSelectAll] = useState(false);

  const [role, setRole] = useState(initialRole);
  const statusOptions = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ];

  // set modal type
  const setModal = (type = 0, roleData = {}) => {
    setroleModal(!roleModal);
    setModalType(type);
    if ((type === 2 || type === 3) && roleData) {
      setId(roleData.id);
      setTitle(roleData.title);
      setStatus(roleData.status);

      let parsedPermissions = {};
      if (typeof roleData.permissions === "string") {
        try {
          parsedPermissions = JSON.parse(roleData.permissions);
        } catch (e) {
          console.error("Failed to parse permissions", e);
        }
      } else {
        parsedPermissions = roleData.permissions || {};
      }

     
      let count = 0;
      let total = 0;
      Object.keys(parsedPermissions).forEach((key) => {
        if (
          key !== "status" &&
          key !== "title" &&
          key !== "superAdminRole" &&
          key !== "_id" &&
          key !== "id"
        ) {
          total++;
          if (parsedPermissions[key] === true) count++;
        }
      });

      setSelectAll(total > 0 && count === total);
      setRole({ ...initialRole, ...parsedPermissions });
    }
    if (type === 1) {
      setEmpty();
    }
  };
  const setEmpty = () => {
    setTitle("");
    setStatus(true);
    setSelectAll(false);
    setRole(initialRole);
    setId(null);
  };

  const getData = (role) => {
    setRole(role);
    refetch();
  };

  const [deleteRoleMut, { isLoading: isDeletingRole }] = useDeleteRoleMutation();
  const deleteRoleHandler = (roleId) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        (async () => {
          await deleteRoleMut(roleId);
          await refetch();
        })();
      }
    });
  };

  const [qs, setQs] = useState("");
  const onSearch = () => {
    if (search || searchStatus) {
      setResetButton(true);
      const qs = ENV.objectToQueryString({
        title: search.trim(),
        status: searchStatus,
      });
      setQs(qs);
      setModalType(0);
    } else {
      toast.error("Add title or select status to be searched.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch();
    }
  };

  const reset = () => {
    setResetButton(false);
    setSearch("");
    setSearchStatus("");
    setQs("");
  };

  const onPageChange = (page) => {
    const qs = ENV.objectToQueryString({
      page,
      limit,
      title: search.trim(),
      status: searchStatus,
    });
    setQs(qs);
  };

  // const dispatch = useDispatch();
  useEffect(() => {
    let roleEncrypted = localStorage.getItem("role");
    let role = "";
    if (roleEncrypted) {
      let roleDecrypted = CryptoJS.AES.decrypt(
        roleEncrypted,
        ENV.secretKey
      ).toString(CryptoJS.enc.Utf8);
      setCurrentRoleId(roleDecrypted);
      role = roleDecrypted;
    }
    setCurrentRoleId(role !== "" ? role : null);
  }, []);

  const { data: rolesData, refetch, isLoading: isRolesLoading, isFetching: isRolesFetching } = useGetRolesQuery(qs);
  useEffect(() => {
    if (rolesData) {
      const data = rolesData.data ?? rolesData.roles ?? rolesData;
      setRoles(data);
      setPage(rolesData.page ?? page);
      setPages(rolesData.pages ?? pages);
      setTotal(rolesData.total ?? total);
      setLimit(rolesData.limit ?? limit);
    }
  }, [rolesData]);

  const { data: permissionData, isLoading: isPermissionLoading } = useGetPermissionQuery(currentRoleId, { skip: !currentRoleId });
  useEffect(() => {
    if (permissionData && permissionData.role?.permissions) {
      const perms = typeof permissionData.role.permissions === 'string' 
        ? JSON.parse(permissionData.role.permissions) 
        : permissionData.role.permissions;
      setCurrentUserRole(perms);
    }
  }, [permissionData]);

  const isGlobalLoading = isRolesLoading || isRolesFetching || isPermissionLoading || isDeletingRole;

  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Container fluid>
          <Row>
            <Col md="12">
              <Card className="filter-card card">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">
                      Filters
                    </Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6} className="search-wrap">
                      <Form.Group>
                        <Form.Label className="d-block mb-2">
                          Search with title...
                        </Form.Label>
                        <Form.Control
                          type="email"
                          onKeyPress={handleKeyPress}
                          name="search"
                          placeholder="Search"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with status...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Select Status"
                          name="status"
                          options={statusOptions}
                          onChange={(e) => setSearchStatus(e ? e.value : "")}
                          value={statusOptions.filter(
                            (l) => l.value === searchStatus
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                      <Form.Group>
                        <label className="d-none d-sm-block mb-2 form-label">
                          &nbsp;
                        </label>
                        <div className="d-flex  filter-btns-holder">
                          <button
                            type="button"
                            className="btn-filled mr-3"
                            onClick={onSearch}
                          >
                            Search
                          </button>
                          {resetButton && (
                            <button
                              type="button"
                              className="outline-button"
                              onClick={reset}
                            >
                              Reset
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Card className="table-big-boy">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Permissions</Card.Title>
                    {currentUserRole?.addRole && (
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center"
                        onClick={() => setModal(1)}
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add New Role
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="table-full-width">
                  <div className="table-responsive">
                    <Table className="table-bigboy">
                      <thead>
                        <tr>
                          <th className="td-start text-center">#</th>
                          <th className="td-name text-center">Title</th>
                          <th className="text-center td-status td-name text-center">
                            Status
                          </th>
                          <th className="td-actions text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {roles && roles.length > 0 ? (
                          roles.map((val, key) => {
                            return (
                              <tr key={key} className="align-items-center">
                                <td className="text-center">
                                  {limit * page - limit + key + 1}
                                </td>
                                <td className="td-name text-center">
                                  {val.title}
                                </td>
                                <td className="text-center td-name">
                                  {val.status ? (
                                    <label className="label label-success m-0">
                                      Active
                                    </label>
                                  ) : (
                                    <label className="label label-danger m-0">
                                      Inactive
                                    </label>
                                  )}
                                </td>
                                <td className="td-actions text-center">
                                  <ul className="list-unstyled mb-0 d-flex justify-content-center">
                                    {currentUserRole?.viewRole ? (
                                      <li className="d-inline-block align-top">
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip id="tooltip-436082023">
                                              View
                                            </Tooltip>
                                          }
                                          placement="left"
                                        >
                                          <button
                                            type="button"
                                            className="btn-link btn-icon btn btn-info"
                                            onClick={() => setModal(2, val)}
                                          >
                                            <FaEye />
                                          </button>
                                        </OverlayTrigger>
                                      </li>
                                    ) : null}
                                    {currentUserRole?.editRole ? (
                                      <li className="d-inline-block align-top">
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip id="tooltip-436082023">
                                              Edit
                                            </Tooltip>
                                          }
                                          placement="left"
                                        >
                                          <button
                                            type="button"
                                            className="btn-link btn-icon btn btn-success"
                                            disabled={
                                              Number(currentRoleId) ===
                                                val.id || val.superAdminRole
                                            }
                                            onClick={() => setModal(3, val)}
                                          >
                                            <FaEdit />
                                          </button>
                                        </OverlayTrigger>
                                      </li>
                                    ) : null}
                                    {currentUserRole?.deleteRole ? (
                                      <li className="d-inline-block align-top">
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip id="tooltip-436082023">
                                              Delete
                                            </Tooltip>
                                          }
                                          placement="left"
                                        >
                                          <button
                                            type="button"
                                            className="btn-link btn-icon btn btn-danger"
                                            disabled={
                                              Number(currentRoleId) ===
                                                val.id || val.superAdminRole
                                            }
                                            onClick={() =>
                                              deleteRoleHandler(val.id)
                                            }
                                          >
                                            <FaTrash />
                                          </button>
                                        </OverlayTrigger>
                                      </li>
                                    ) : null}
                                  </ul>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center px-0" colSpan="4">
                              <span className="alert alert-info d-block text-center">
                                No Record Found
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    <Col className="pb-4">
                      <Pagination
                        defaultCurrent={1}
                        pageSize // items per page
                        current={page} // current active page
                        total={pages} // total pages
                        onChange={onPageChange}
                        locale={localeInfo}
                      />
                    </Col>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <PermissionsModal
            key={`${modalType}-${id}`}
            setData={getData}
            modalType={modalType}
            setModalType={setModalType}
            roleModal={roleModal}
            setroleModal={setroleModal}
            role={role}
            title={title}
            status={status}
            setTitle={setTitle}
            setStatus={setStatus}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            id={id}
            setId={setId}
          />


      </Container>
    </>
  );
};

export default StaffPermissions;
